module.exports = __webpack_public_path__ + "static/img/nav_bg_fixed.eb2f87cb.png";